module.exports = __webpack_public_path__ + "static/img/preview-05.a3c1f60f.webp";